import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import formRegister from "../../docs/formRegister.json";
import { mergePreservedClaimSections } from "../preserveClaimSections.js";
import { uniformClaimDeadline } from "commonAssets/lib/uniformClaimDeadline";
import { outputDiv, loading } from "commonAssets/js/constants";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { loadMember } from "commonAssets/lib/loadMember";

export class customRegistration extends SubmitClaim {
    async form() {
        const form = formRegister.claim_form[this.lang];
        this.init_claim(form);
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        console.log("[customRegistration:populate_claim_form]");

        this.errorHandler.set_user({
            id: class_member.zero_zero_id,
            email: class_member.email_address,
        });

        document.getElementById("guard")?.remove();

        const deadlineSpan = uniformClaimDeadline(claim_deadline);
        container.appendChild(this.claim_form(form, deadlineSpan));
        container.scrollIntoView({ behavior: "smooth" });
        outputDiv.appendChild(container);
        loadingGif(loading, "hide", 250);

        const documentationExists = Boolean(
            document.getElementById("documentation")
        );
        const memberForLoad = documentationExists
            ? class_member
            : { ...class_member, claim_files: [] };

        loadMember(memberForLoad);

        if (this.customLoadMember != null) {
            this.customLoadMember(this.claim);
        }

        this.init_claim_fields(this.claim, form, claim_deadline);
    }

    async post_claim(claim, s3env) {
        mergePreservedClaimSections(claim);
        return super.post_claim(claim, s3env);
    }

    init_claim_fields(claim, form, claim_deadline) {
        super.init_claim_fields(claim, form, claim_deadline);
        document.getElementById("payment-widget")?.remove();
        ["payment_method", "payment_token", "payment_email", "payment_phone"].forEach(
            (id) => document.getElementById(id)?.remove()
        );

        const confirmationEmailAlert = document.getElementById(
            "confirmation-email-alert"
        );
        const generalInstructionsBody = document.querySelector(
            "#generalInstructions .bg-light"
        );
        const myDgAlert = generalInstructionsBody?.querySelector(
            ".alert.alert-warning"
        );

        if (confirmationEmailAlert && generalInstructionsBody && myDgAlert) {
            myDgAlert.insertAdjacentElement("afterend", confirmationEmailAlert);
        }
    }

    process_claim(e, claim, deadline) {
        console.log("[customRegistration:process_claim]");

        const previousCustomProcessClaim = this.customProcessClaim;
        const previousCustomDstProcess = this.customDstProcess;

        // Bypass shared customProcessClaim and DST payment enforcement for registration.
        this.customProcessClaim = null;
        this.customDstProcess = (c) => c;

        try {
            return super.process_claim(e, claim, deadline);
        } finally {
            this.customProcessClaim = previousCustomProcessClaim;
            this.customDstProcess = previousCustomDstProcess;
        }
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customRegistration(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }
}

export function customRegisterForm(options) {
    return customRegistration.createInstance(options);
}
